import btnStyles from '../../styles/button.module.css';
import { theme } from '../../styles/theme';
import { FontVariant } from '../../styles/style.interfaces';

interface Props {
  text: string;
  link: string;
  color?: string;
  fontStyle?: FontVariant;
  isArrow?: boolean;
}

function resolveColor(c: string) {
  return c === 'black' ? theme.colors.black : c;
}

export default function BlankLinkHoverBtn({
  text,
  link,
  color = 'black',
  fontStyle = 'alt',
  isArrow = false,
}: Props) {
  const fg = resolveColor(color);
  const fontClass = fontStyle === 'alt' ? 'fontVariantAlt' : 'fontVariantDefault';
  const Inner = isArrow ? btnStyles.arrowInnerText : btnStyles.innerText;

  return (
    <a
      className={`${btnStyles.hoverFill} ${fontClass} link_btn`}
      style={{ color: fg, borderColor: fg }}
      href={link}
      target="_blank"
      rel="noopener noreferrer"
    >
      <span className={Inner}>{text}</span>
    </a>
  );
}
